import React from 'react';
import { IconBaseProps } from 'react-icons';

type IconProps = {
  icon: React.ReactElement;
  className?: string;
} & IconBaseProps;

export const Icon: React.FC<IconProps> = ({ size = 24, icon, ...props }) =>
  React.cloneElement(icon, { size, ...props });
